import React,{useEffect} from "react"
// import './VideoAds.css'
import videoAdsBanner from '../../assets/bannerImages/videoAdsBanner.jpg'
import googleadsLogo from '../../assets/logos/googleadsLogo.jpg'
import metaadsLogo from '../../assets/logos/metaadsLogo.jpg'
import microsoftadsLogo from '../../assets/logos/microsoftadsLogo.jpg'
import linkedinLogo from '../../assets/logos/linkedinLogo.jpg'
import { Link } from "react-router-dom"

import creativeExcellence from '../../assets/images/creativeContent.jpg'
import targetedReach from '../../assets/images/targetedStrategies.jpg'
import measurableGrowth from '../../assets/images/maximizedROI.jpg'

import creativeConceptualization from '../../assets/images/engagingContentCreation.jpg'
import productExcellence from '../../assets/images/productionExcellence.jpg'
import strategicDistribution from '../../assets/images/strategicDistribution.jpg'

export default function VideoAds(){

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      },[]);

    return(
        <div className="videoAds">
            <VAR1/>
            <VAR2/>
            <VAR3/>
            <VAR4/>
            <ContactSection/>
            {/* this contact section's css is in social media marketing page's css file */}
        </div>
    )
}

function VAR1(){
    return(
        <div className='var1'>
            <img loading="lazy" src={videoAdsBanner} alt='va-banner' className='va-banner-img'/>
            <h1 className='var1-head'>Video Ads</h1>
            <div className='overlay'></div>
        </div>
    )
}

function VAR2(){
    return(
        <div className='var2'>
            <div className='strip'>
                <h1>What are <span>Video Ads</span>?</h1>
                <hr/>   
                <p>Video Ads are impactful marketing tools that leverage dynamic visuals to engage audiences and convey brand messages effectively. Through compelling narratives and captivating imagery, Video Ads enable businesses to showcase their products or services in a memorable and engaging manner, driving brand awareness and customer engagement.</p>
            </div>
        </div>
    )
}

function VAR3(){
    return(
        <div className='var3'>
            <div className='rowThreeContainer'>
                <h1 className='rowThreeHead'>
                Why <span>Choose Bixian</span> for Video Ads?
                </h1>
                <p className='rowThreeContext'>
                Bixian stands out as the premier choice for Video Ads, offering unparalleled expertise and comprehensive solutions. With our dedicated approach, advanced technology, and commitment to excellence, we deliver results that exceed expectations.
                </p>
                <div className='rowThreeBoxes'>
                    {/* box 1 */}
                    <div className='box boxOne'>
                        <div className='context'>
                            <img loading="lazy" src={creativeExcellence} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Creative Excellence
                            </h2>
                            <p className='boxPara'>
                            Bixian's team of creative experts specializes in crafting compelling and visually stunning Video Ads that captivate audiences and drive engagement, ensuring maximum impact and effectiveness.
                            </p>
                        </div>
                    </div>
                    {/* box 2 */}
                    <div className='box boxTwo'>
                        <div className='context'>
                            <img loading="lazy" src={targetedReach} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Targeted Reach
                            </h2>
                            <p className='boxPara'>
                            Leveraging advanced targeting tools and strategies, we ensure that your Video Ads are delivered to the right audience, at the right time, and on the right platforms, maximizing reach and engagement.
                            </p>
                        </div>
                    </div>
                    {/* box 3 */}
                    <div className='box boxThree'>
                        <div className='context'>
                            <img loading="lazy" src={measurableGrowth} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Measurable Results
                            </h2>
                            <p className='boxPara'>
                            With Bixian, you can expect transparent and measurable results, as we provide detailed analytics and insights to track the performance of your Video Ads, allowing for continuous optimization and improvement.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

function VAR4(){
    return(
        <div className='var4'>
            <div className='rowFourContainer'>
                <div className='rowFourContext'>
                    <h1 className='rowFourHead'>Our Process</h1>
                    <p className='rowFourPara'>
                    Unlock the potential of Video Advertising with Bixian's streamlined process. We understand the importance of captivating visuals and compelling storytelling to engage your audience effectively.
                    </p>
                </div>
                <div className='rowFourBoxes'>
                    <div className='box boxOne'>
                            <img loading="lazy" src={creativeConceptualization} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Creative Conceptualization</h2>
                        <p className='boxPara'>Our team collaborates with you to develop creative concepts that align with your brand identity and resonate with your target audience.</p>
                    </div>
                    <div className='box boxTwo'>
                            <img loading="lazy" src={productExcellence} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Production Excellence</h2>
                        <p className='boxPara'>We bring your vision to life with high-quality video production, incorporating dynamic visuals, engaging narratives, and professional editing techniques.</p>
                    </div>
                    <div className='box boxThree'>
                            <img loading="lazy" src={strategicDistribution} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Strategic Distribution</h2>
                        <p className='boxPara'>Leveraging our expertise in digital marketing, we strategically distribute your Video Ads across relevant platforms to maximize reach and engagement, ensuring optimal ROI.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss More About Our Video Ads?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}